module.exports = __webpack_public_path__ + "img/qrcode_official.8957d4e8.png";